export const appViewState = {
  firstTime: true,
  Profile: {
    'Contact Information': {
      done: false
    },
    'Preliminary Information': {
      done: false
    }
  },
  Instructions: {
    Instructions: {
      done: false
    }
  },
  Preferences: {
    'Availability Information': {
      done: false
    },
    'Home Office Setup': {
      done: false
    }
  },
  Experience: {
    'Career Summary': {
      done: false
    },
    'Work Experience': {
      done: false
    },
    'Employment Gaps': {
      done: false
    }
  },
  Skills: {
    Instructions: {
      done: false
    },
    'Industry Segments': {
      done: false
    },
    'Firm Types': {
      done: false
    },
    Positions: {
      done: false
    },
    Departments: {
      done: false
    },
    'Areas of Expertise': {
      done: false
    },
    'Mgmt Systems': {
      done: false
    },
    'Computer Skills': {
      done: false
    },
    'Rating Systems': {
      done: false
    },
    Languages: {
      done: false
    }
  },
  'Summary of Skills': {
    'Summary of Skills' : {
      done: false
    }
  },
  Background: {
    Licenses: {
      done: false
    },
    Education: {
      done: false
    },
    'Professional Associations': {
      done: false
    },
    'Professional Designations': {
      done: false
    },
    'Additional Professional References': {
      done: false
    }
  },
  Documents: {
    done: false
  },
  Submit: {
    done: false
  },
  Assessments: {
    done: false
  }
};



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/appViewState.js